module.exports = __webpack_public_path__ + "media/images/countrysquared/bm-568995c24bac0f0556ad003a2f578311.svg";